import React from "react";
import { styled } from "@mui/material/styles";

// Container
const BoardingPassContainer = styled("div")({
  position: "relative",
  left: "0.7rem",
  width: "91%",
  height: "230px",
  background: "#fff",
  borderRadius: "8px",
  boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 1px 1px",
  overflow: "hidden",
  textTransform: "uppercase",
  marginBottom: "10px",
});

// Header
const Header = styled("header")({
  background: "linear-gradient(to bottom, #264b76 0%, #002c5f 100%)",
  padding: "12px 16px",
  height: "55px",
  borderBottom: "4px solid #6dbe47",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

// Logo Section
const LogoDiv = styled("div")({
  color: "white",
  width: "230px",
  height: "31px",
});

// Placeholder if styles are added dynamically
const FlightInfoDiv = styled("div")({});

// Cities Section
const SectionCities = styled("section")({
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
});

// Plane Icon
const PlaneIcon = styled("div")({
  display: "flex",
  padding: "10px",
  "& img": {
    width: "30px",
  },
});

// Info Section
const SectionInfos = styled("section")({
  display: "flex",
  borderTop: "1px solid #99d298",
});

// Left Box
const FlightInfoBox = styled("div")({
  background: "#e2efe2",
  borderRight: "1px solid #99d298",
  width: "45%",
});

// Right Box
const FlightTimesBox = styled("div")({
  width: "50%",
});

// Strap Section
const SectionStrap = styled("section")({
  clear: "both",
  position: "relative",
  borderTop: "1px solid #99d298",
});

// QR Code
const QRCodeImg = styled("img")({
  position: "absolute",
  top: "3px",
  right: "20px",
  width: "80px",
  height: "80px",
});

const FlightInfo = ({ name, code, cssDiv, cssSmall, cssStrong }) => {
  return (
    <FlightInfoDiv style={cssDiv}>
      <small style={cssSmall}>{name}</small>
      <strong style={cssStrong}>{code}</strong>
    </FlightInfoDiv>
  );
};

const RenderBoardingPass = ({ detail }) => {
  return (
    <BoardingPassContainer>
      <Header>
        <FlightInfoDiv style={{ color: "#fff", textAlign: "right" }}>
          <small
            style={{
              fontSize: "10px",
              marginBottom: "2px",
              opacity: "0.8",
              fontWeight: "900",
            }}
          >
            {"flight PNR"}
          </small>
          <strong style={{ fontSize: "18px", marginLeft: "10px" }}>
            {detail.pnr}
          </strong>
        </FlightInfoDiv>
      </Header>

      <SectionCities>
        <FlightInfo
          name="Departure City"
          code={detail?.origin}
          cssDiv={{ padding: "15px 18px", float: "left" }}
          cssSmall={{ marginBottom: "0px", marginLeft: "3px" }}
          cssStrong={{ fontSize: "35px", fontWeight: "300", lineHeight: "1" }}
        />
        <PlaneIcon>
          <img
            src="https://cdn.onlinewebfonts.com/svg/img_537856.svg"
            alt="Plane"
          />
        </PlaneIcon>
        <FlightInfo
          name="Arrival City"
          code={detail?.destination}
          cssDiv={{ padding: "15px 18px", float: "right" }}
          cssSmall={{ marginBottom: "0px", marginLeft: "3px" }}
          cssStrong={{ fontSize: "35px", fontWeight: "300", lineHeight: "1" }}
        />
      </SectionCities>

      <SectionInfos></SectionInfos>

      <SectionStrap>
        <FlightInfo
          name="passenger"
          code={detail.name}
          cssDiv={{ margin: "10% 2%" }}
          cssSmall={{ fontSize: "10px" }}
          cssStrong={{ fontSize: "13px", marginLeft: "10px" }}
        />

        <QRCodeImg
          src="https://dolphinchat-chat.s3.ap-south-1.amazonaws.com/publicURLS/3e9c86447ad14afb8b260fe48efe0eb0/1729055510334_QR_code_for_mobile_English_Wikipedia.svg.png"
          alt="QR Code"
        />
      </SectionStrap>
    </BoardingPassContainer>
  );
};

export default RenderBoardingPass;
